export const UserScopes = {
    CellTrak: "CellTrak",
    Customer: "Customer"
} as const;

export type UserScope = typeof UserScopes[keyof typeof UserScopes];
